import { AxiosRequestHeaders } from 'axios';
import { AuthStorageService } from '../../auth/auth-storage.service';
import { InternalHttpServiceRequestHeaders } from '../http.service';

const _shouldAppendBearerToken = (
  allowListBearer?: (string | RegExp)[],
  disallowListBearer?: (string | RegExp)[],
  url?: string,
  baseUrl?: string
) => {
  if (!url) {
    return false;
  }

  if (url.includes('.well-known/openid-configuration')) {
    return false;
  }

  if (
    disallowListBearer?.some((disallowUrl: string | RegExp) => {
      if (typeof disallowUrl === 'string') {
        return url.includes(disallowUrl) || baseUrl?.includes(disallowUrl);
      }

      return disallowUrl.test(url) || (baseUrl && disallowUrl.test(baseUrl));
    })
  ) {
    return !!allowListBearer?.some((allowUrl: string | RegExp) => {
      if (typeof allowUrl === 'string') {
        return url.includes(allowUrl);
      }

      return allowUrl.test(url);
    });
  }

  if (!allowListBearer?.length) {
    return true;
  }

  return allowListBearer.some((allowUrl: string | RegExp) => {
    if (typeof allowUrl === 'string') {
      return url.includes(allowUrl);
    }

    return allowUrl.test(url);
  });
};

export const bearerTokenInterceptor = (config: InternalHttpServiceRequestHeaders): InternalHttpServiceRequestHeaders => {
  if (!config.headers) {
    (config.headers as Partial<AxiosRequestHeaders>) = {
      'Content-Type': 'application/json',
    };
  }
  if (
    typeof window !== 'undefined' &&
    _shouldAppendBearerToken(config?.allowListBearer, config?.disallowListBearer, config?.url, config?.baseURL)
  ) {
    const accessToken = AuthStorageService.getAccessToken();

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
  }

  return config;
};
